// Toggle a non-inventory brand card's name between display and edit mode, and save changes to
// Brand#display_name. Scoped to the closest .brand-card since many brand cards render on one page.
$(document).on('click', '.brand-name-edit-button', function () {
  const $card = $(this).closest('.brand-card');
  $card.find('.brand-name-display, .brand-name-edit-button').addClass('d-none');
  $card.find('.brand-name-edit-form').removeClass('d-none');
  $card.find('.brand-name-input').trigger('focus').trigger('select');
});

$(document).on('click', '.brand-name-cancel-button', function () {
  const $card = $(this).closest('.brand-card');
  $card.find('.brand-name-input').val($card.find('.brand-name-display').text());
  $card.find('.brand-name-edit-result').empty();
  $card.find('.brand-name-edit-form').addClass('d-none');
  $card.find('.brand-name-display, .brand-name-edit-button').removeClass('d-none');
});

$(document).on('click', '.brand-name-save-button', function () {
  const $card = $(this).closest('.brand-card');
  const $button = $(this);
  const $input = $card.find('.brand-name-input');
  const $result = $card.find('.brand-name-edit-result');
  const brandId = $input.data('brand-id');
  const displayName = $input.val().trim();

  $result.empty();

  if (!displayName) {
    $result.html('<div class="text-danger">Brand name cannot be blank.</div>');
    return;
  }

  $button.prop('disabled', true);

  $.ajax({
    url: `/non_inventory_brands/${brandId}/update_name`,
    type: 'PATCH',
    data: { display_name: displayName }
  }).done(function (data) {
    if (data.success) {
      $card.find('.brand-name-display').text(data.display_name);
      $card.find('.brand-name-edit-form').addClass('d-none');
      $card.find('.brand-name-display, .brand-name-edit-button').removeClass('d-none');
      return;
    }

    $result.html('<div class="text-danger">' + data.errors + '</div>');
  }).fail(function (jqXHR) {
    const message = (jqXHR.responseJSON && jqXHR.responseJSON.errors) || 'Something went wrong.';
    $result.html('<div class="text-danger">' + message + '</div>');
  }).always(function () {
    $button.prop('disabled', false);
  });
});
